import { Component, Input, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatSliderChange } from '@angular/material/slider';
import { Subscription, first, pairwise, startWith } from 'rxjs';
import { CurrencyMaskOptions } from 'src/app/modules/shared/shared.constants';
import { HrDataService } from '../../hr.service';
import { NotOnlySpaces } from '../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import { EmailValidator } from '../../../shared/CustomValidators/CustomInvalidEmailValidator';
import {WebsiteURLValidator} from '../../../shared/CustomValidators/CustomWebsiteUrlValidator';
import {PhoneNumberValidator} from '../../../shared/CustomValidators/CustomInvalidPhoneNumberValidator';
import { StaffService } from 'src/app/services/staff/staff.service';
import { SharedService } from 'src/app/modules/shared/shared.service';
import { CoreService } from 'src/app/services/core/core.service';
import { UserService } from 'src/app/services/core/user.service';
@Component({
    selector: 'app-staff-detail',
    templateUrl: './staff-detail.component.html',
    styleUrls: ['./staff-detail.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StaffDetailComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => StaffDetailComponent),
            multi: true
        }
    ],
    standalone: false
})
export class StaffDetailComponent implements OnInit {
  public CreditLimit: boolean = false;
  public currencyMaskOptions = CurrencyMaskOptions;
  public staffDetailFormSubscription: Subscription | undefined;
  public isFormTouched = false;
  @Input() form: any = {};
  @Input() isEdit : boolean = false;
  @Input() model: any = {};
  public staffs: any[] = [];
  rolesList : any = [];
  activeDepartments : any = [];
  languageTimeZone: any =[]
  departmentItems : any = [
   {id: 1 , name: 'Staff-department-1'},
   {id: 2 , name: 'Staff-department-2'}
  ]
  public staffDetailForm: UntypedFormGroup = new UntypedFormGroup({
    phone_number: new UntypedFormControl(null,[Validators.required,PhoneNumberValidator()]),
    extension: new UntypedFormControl(null),
    department: new UntypedFormControl(null,[Validators.required]),
    language: new UntypedFormControl(null,[Validators.required]),
    time_zone: new UntypedFormControl(null,[Validators.required]),
    roles: new UntypedFormControl(null,[Validators.required]),
    supervisors: new UntypedFormControl(null,[]),
    start_date: new UntypedFormControl(null,[Validators.required]),
    birthday: new UntypedFormControl(null,[Validators.required]),
  });
  constructor(
    private hrDataService: HrDataService,
    private sharedService: SharedService,
    private staffService: StaffService,
    public coreService: CoreService,
    private currentUser: UserService,

  ) { }

  ngOnInit(): void {
    this.initSubscriptions()
    this.getRoles()
    this.getLanguageTimezone()
  }

  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
  }

  ngAfterViewInit(): void {
    this.setDataOnEdit();
    this.getActiveDepartments();
    this.getStaffs({},'all');
  }


  getStaffNameByItsId(departmentId: string){
    const parsedDepartmentId = Number(departmentId);
    const department = this.departmentItems.find((dep:any) => dep.id === parsedDepartmentId);
    return department ? department.name : '';
  }

  setDataOnEdit = () => {
    if(this.isEdit) {
      this.staffDetailForm.get('phone_number')?.setValue(this?.model?.staff_detail?.phone_number);
      this.staffDetailForm.get('extension')?.setValue(this?.model?.staff_detail?.extension);

      const departmentId = {id:this.model?.staff_detail?.department?.id,name:this.model?.staff_detail?.department?.name};
      // const departmentName = this.getStaffNameByItsId(departmentId);
      this.staffDetailForm.get('department')?.setValue(departmentId);

      this.staffDetailForm.get('language')?.setValue(this?.model?.staff_detail?.language);
      this.staffDetailForm.get('time_zone')?.setValue(this?.model?.staff_detail?.time_zone);
      this.staffDetailForm.get('roles')?.setValue(this?.model?.roles);
      this.staffDetailForm.get('supervisors')?.setValue(this?.model?.supervisors);
      this.staffDetailForm.get('start_date')?.setValue(this?.model?.staff_detail?.start_date);
      this.staffDetailForm.get('birthday')?.setValue(this?.model?.staff_detail?.birthday);
    }
  }

 //getting role-list
  getRoles() {
    this.hrDataService.getRoles()
      .pipe(first())
      .subscribe((response) => {
        this.rolesList = response?.data;
      });
  }

  //getting active-departments
  getActiveDepartments() {
    this.hrDataService.getActiveDepartments()
      .pipe(first())
      .subscribe((response) => {

        this.activeDepartments = response?.data;
      });
  }

  getStaffs = (queryParam: any, type: string) => {
    this.sharedService.getStaffs(queryParam)
      .pipe(first())
      .subscribe(
        (data:any) => {
          let currentStaffList: any = [];
          if(this.isEdit) {
             currentStaffList = [this.model?.supervisors?.map((supervisor: any) => supervisor.id)];
          }
          this.staffs = this.staffService.processStaff(data.data,currentStaffList);
          // const current_user_id = this.currentUser.getID;
          this.staffs = this.staffs.filter(staff => staff.id !== this.model?.id);
          this.setDataOnEdit();
          // this.staffs =  this.staffService.processStaff(data.data,currentStaffList);
          
          // this.staffs = data.data.map((staff:any)=>{
          //   return {id: staff.id, name: `${staff.first_name} ${staff.last_name}`};
          // });
        });
  }

  //getting language + timezone List
  getLanguageTimezone() {
    this.hrDataService.getLanguageTimeZone()
      .pipe(first())
      .subscribe((response) => {
        this.languageTimeZone = response?.data;
        this.languageTimeZone.languages = this.sortLanguages(response?.data?.languages);

        // Auto-select the default Time Zone (Settings > Localization > Language & Region)
        // only when creating a new staff member. Edit mode keeps setDataOnEdit()'s own
        // saved time zone and is never touched here.
        if (!this.isEdit) {
          this.setDefaultTimezoneForCreate();
        }
      });
  }

  //auto-selects the default Time Zone from Settings > Localization, for CREATE mode only
  setDefaultTimezoneForCreate() {
    this.hrDataService.getLocalization()
      .pipe(first())
      .subscribe((response) => {
        const defaultTimezoneId = response?.data?.time_zone;
        const matchedTimezone = this.languageTimeZone?.timezone?.find((tz: any) => tz.id == defaultTimezoneId);
        if (matchedTimezone) {
          this.staffDetailForm.get('time_zone')?.setValue(matchedTimezone);
        }
      });
  }

  private sortLanguages(languages: any[]): any[] {
    if (!Array.isArray(languages)) {
      return languages;
    }
    const isEnglish = (name: string) => (name || '') === 'English' || (name || '').startsWith('English (');
    return [...languages].sort((a, b) => {
      const aEnglish = isEnglish(a?.name);
      const bEnglish = isEnglish(b?.name);
      if (aEnglish && !bEnglish) return -1;
      if (!aEnglish && bEnglish) return 1;
      return (a?.name || '').localeCompare(b?.name || '');
    });
  }

  onChangeCreditLimit() {
    this.CreditLimit = !this.CreditLimit;
  }
  formatLabel(value: number) {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return value;
  }

  writeValue(val: any): void {
    val && this.staffDetailForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.staffDetailForm.valueChanges.subscribe(fn);
  }


  public onTouched: () => void = () => {};

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.staffDetailForm.disable() : this.staffDetailForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.staffDetailForm.valid ? null : { invalidForm: {valid: false, message: "Company name fields are invalid"}};
  }

  initSubscriptions(){
    if (this.form){
      this.staffDetailFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched && !this.isFormTouched){
            this.isFormTouched = true;
            this.touchFormControls();
          }
        });
    }
  }

  touchFormControls(){
    Object.keys(this.staffDetailForm.controls).forEach(key => {
      this.staffDetailForm.get(key)?.markAsTouched();
    });
  }
  onInputChange(event: MatSliderChange) {
    console.log(event.value);
  }
}
